import React, {useRef, useState} from 'react';
import PageHeaderComponent from '../../../helpers/components/page_header.component';
import {Divider, List, Radio, Space} from 'antd';
import FilterBullet from '../../../helpers/components/filter_bullet';
import {CaretDownFilled} from '@ant-design/icons';
import serviceHelper from '../../../helpers/functions/service.helper';
import CustomerListTable from "./customer_list_table";
import MerchantListTable from "./merchant_list_table";

const BalanceLayout = ({ default_filter }) => {
    const { innerWidth } = window;
    const componentRef = useRef();
    const [state, setState] = useState({
        merchants: []
    });

    const [filter, setFilter] = useState({
        option_value : default_filter?.option_value,
    });


    const onChange = (key, checkedValues) => {
        setFilter(filter => ({...filter, [key] : checkedValues}))
        changeFilter(key, checkedValues);
    }

    // for changing filter
    const changeFilter = (key, value) => {
        let generate_filter = default_filter;
        generate_filter[key] = value;
        const queryString = serviceHelper?.queryString(generate_filter);
        window.history.replaceState({}, '', `${window.location.pathname}?${queryString}`);
    }


    // const exportExcel = async () => {
    //     setExportLoading(true);
    //     const { merchant_id, } = filter;
    //     const response = await MerchantService?.payment_report({
    //         merchant_id,
    //     });
    //     const {  rows } = response?.data?.payments;
    //
    //     const exportRows = rows.map((v, index) => {
    //         const { activity_status,from_wallet, created_at, transaction_no,melon_amount } = v;
    //
    //         return {
    //             "No": index + 1,
    //             "Name": from_wallet?.customer?.name || "-",
    //             "Wallet": from_wallet?.name || "-",
    //             "Phone No.": `${from_wallet?.customer.mobile_dial_no}${from_wallet?.customer.phone_no}` || "-",
    //             "Transaction No.": transaction_no || "-",
    //             "Amount": melon_amount != null ? Number(melon_amount).toFixed(2) : "0.00",
    //             "Status": activity_status?.name || "-",
    //             "Date": moment(created_at)?.isValid() ? moment(created_at).format("DD MMM YYYY HH:mm") : "",
    //         };
    //     });
    //
    //     globalHelper.exportToExcel({
    //         data : exportRows,
    //         name : `merchant_report_${moment()?.format("YYYYMMDD")}`,
    //     });
    //
    //     setExportLoading(false);
    //     // setState(state => ({...state, generate_loading : false, }));
    // }

    const options = [
        { label: 'Customer', value: 'customer' },
        { label: 'Merchant', value: 'merchant' },
    ];


    return (
        <>
            <div className='mobile-padding-12'>
                <div style={{marginBottom: 24, textAlign: 'start'}}>
                    <PageHeaderComponent title={'Melon Balance Report'}/>
                </div>
                <div className='filter-panel'>
                    <div style={{display: 'flex', alignItems: 'center',}}>
                        <div style={{textAlign: 'start',}}>
                            <Space direction={innerWidth > 768 ? 'horizontal' : 'vertical'}>
                                <FilterBullet
                                    popover={
                                        <>
                                            {/*<div>*/}
                                            {/*    <Input*/}
                                            {/*        prefix={<SearchOutlined style={{ color: 'var(--secondary-text-color)' }} />}*/}
                                            {/*        placeholder='Search Merchant'*/}
                                            {/*        value={merchantSearch}*/}
                                            {/*        onChange={(e) => setMerchantSearch(e.target.value)}*/}
                                            {/*    />*/}
                                            {/*</div>*/}
                                            <Radio.Group
                                                value={filter?.option_value}
                                                onChange={(e) => onChange('option_value', e.target.value)}
                                            >
                                                <List
                                                    style={{width: 280}}
                                                    dataSource={options}
                                                    renderItem={(item) => (
                                                        <List.Item style={{width: '100%'}} key={item.value}>
                                                            <div style={{
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                width: '100%'
                                                            }}>
                                                                <div>
                                                                    <span>{item.label}</span>
                                                                </div>
                                                                <div style={{marginLeft: 'auto'}}>
                                                                    <Radio value={item.value}/>
                                                                </div>
                                                            </div>
                                                        </List.Item>
                                                    )}
                                                />
                                            </Radio.Group>
                                        </>
                                    }
                                >
                                    <div>
                                        <Space>
                                            <div>
                                               <span>
                                                    Select: {filter?.option_value || '—'}
                                                </span>
                                            </div>
                                            <div>
                                                <CaretDownFilled style={{color: '#a0aec0'}}/>
                                            </div>
                                        </Space>
                                    </div>
                                </FilterBullet>
                            </Space>
                        </div>
                        {/*<div style={{marginLeft:'auto'}}>*/}
                        {/*    <Button loading={exportLoading} onClick={() => exportExcel()}>*/}
                        {/*        Export*/}
                        {/*    </Button>*/}
                        {/*</div>*/}
                    </div>
                </div>
                <Divider/>
                <div ref={componentRef} style={{marginTop: 12}}>
                    {filter?.option_value === 'customer' && <CustomerListTable filter={filter}/>}
                    {filter?.option_value === 'merchant' && <MerchantListTable filter={filter}/>}
                </div>
            </div>
        </>
    );
}

export default BalanceLayout;